import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageComponent } from 'src/app/popups/message/message.component';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { GalleryManagementService } from 'src/service/gallery-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, BusinessEnabledOption, GalleryType, GeneralConfigType, InteractionType, KeyValues3, LocalService, PageKey, Status, TriggeredEvent, Wrappers5 } from 'src/service/local.service';
import { SellerManagementService } from 'src/service/seller-management.service';

@Component({
  selector: 'app-gallery-biz',
  templateUrl: './gallery-biz.component.html',
  styleUrl: './gallery-biz.component.scss'
})
export class GalleryBizComponent {
  lstSectionConfigKeys: string[] = ["gallery", "table"];
  ctryCode: string = ''; businessId: string = ''; interactionType = 0; maxBodyHeight = 0;
  galleryType: GalleryType = GalleryType.None;
  isImageUploadEnabled: boolean | null = null; businessGalleryTypes: GalleryType[] = [GalleryType.BusinessBanner];
  productGalleryTypes: GalleryType[] = [GalleryType.ProductImage];
  selectedGalleryType: GalleryType = GalleryType.None; isGalleryPopupOpen: boolean = false; selectedParentId: string = '';

  wrapper: Wrappers5;

  constructor(public localService: LocalService, private route: ActivatedRoute, private router: Router, private configurationManagementService: ConfigurationManagementService, private galleryManagementService: GalleryManagementService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private sellerManagementService: SellerManagementService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.galleryType = parseInt(routeParams.galleryType);
      this.configurationManagementService.ensurePageActions(PageKey.GalleryBusiness, this.businessId);
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
        this.onLoad();
      }
    });
  }

  onInitiate(isForce = false) {
    if (!this.localService.galleryTypes || isForce) {
      this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.GalleryType).subscribe(result => {
        this.localService.galleryTypes = result;
      });
    }

    this.sellerManagementService.isBusinessOptionEnabled(BusinessEnabledOption.HasImage, this.businessId).subscribe(result => {
      this.isImageUploadEnabled = result.status == Status.Success;
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad(parentId?: string) {
    this.galleryManagementService.getGalleriesTech(this.galleryType, this.businessId, parentId ?? this.businessId, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
      this.wrapper = result;
    });
  }

  isBusinessOrProductType(key: string, isOnlyProduct = false) {
    let iKey = parseInt(key);
    return isOnlyProduct ? this.productGalleryTypes.indexOf(iKey) > -1 : (this.businessGalleryTypes.indexOf(iKey) > -1 || this.productGalleryTypes.indexOf(iKey) > -1);
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        if (!this.isImageUploadEnabled) {
          const modalRef = this.modalService.open(MessageComponent);
          modalRef.componentInstance.IsConfirmationType = true;
          modalRef.componentInstance.message = this.localService.languageContent.gallery.del_imgs;
          modalRef.result.then((result) => {
            if (result.event == TriggeredEvent.Ok) {
              this.onEnableDisableImageUpload();
            } else {
              this.isImageUploadEnabled = true;
            }
          });
        } else {
          this.onEnableDisableImageUpload();
        }
      } break;
      case 2: {
        this.router.navigate(['/gallery-biz' + this.localService.basicParamsString, this.businessId, key]);
      } break;
      case 3: {
        this.selectedParentId = this.galleryType > 0 ? key : this.businessId;
        this.selectedGalleryType = this.galleryType > 0 ? this.galleryType : parseInt(key);
        this.isGalleryPopupOpen = true;
      } break;
      case 4: {
        this.onDelete(key);
      } break;
      case 5: {
        this.router.navigate(['/gallery-biz' + this.localService.basicParamsString, this.businessId, 0]);
      } break;
    }
  }

  onDelete(key: string) {
    const modalRef = this.modalService.open(MessageComponent);
    modalRef.componentInstance.IsConfirmationType = true;
    modalRef.componentInstance.message = this.localService.languageContent.gallery.del_imgs;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        this.galleryManagementService.removeGallery('', this.galleryType > 0 ? key : '', this.businessId, this.galleryType > 0 ? this.galleryType : (key ? parseInt(key) : GalleryType.None)).subscribe(result => {
          this.onLoad();
        });
      }
    });
  }

  onEnableDisableImageUpload() {
    this.sellerManagementService.activeInactiveStatus(this.businessId, ActiveInactiveFor.ImageUpload).subscribe(result => {
      if (result.status == Status.Success) {
        this.onLoad();
        this.onInitiate();
      }
    });
  }

  onClosesGalleryPopup(e: any) {
    this.onLoad();
  }

  onGetText(index: number, key: string): number {
    let item: KeyValues3 = this.wrapper.items.find(x => x.key == key);
    let data = 0;
    if (item) {
      switch (index) {
        case 1: {
          data = parseFloat(item.v1);
        } break;
        case 2: {
          data = parseFloat(item.v2);
        } break;
      }
    }
    return data;
  }
}
